/**
 * @generated SignedSource<<6a20b7031fd144910dc0c660c326913d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CardBrand = "AMERICAN_EXPRESS" | "CHINA_UNIONPAY" | "DISCOVER" | "DISCOVER_DINERS" | "EBT" | "EFTPOS" | "FELICA" | "INTERAC" | "JCB" | "MASTERCARD" | "OTHER_BRAND" | "SQUARE_CAPITAL_CARD" | "SQUARE_GIFT_CARD" | "UNKNOWN" | "VISA";
export type SelectPaymentModalQuery$variables = {
  customerId: string;
};
export type SelectPaymentModalQuery$data = {
  readonly customer: {
    readonly id?: string;
    readonly squareCards?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly cardBrand: CardBrand;
          readonly enabled: boolean;
          readonly expMonth: number;
          readonly expYear: number;
          readonly id: string;
          readonly lastFour: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ExistingSquareCardsList_customer">;
  } | null | undefined;
};
export type SelectPaymentModalQuery = {
  response: SelectPaymentModalQuery$data;
  variables: SelectPaymentModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customerId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "customerId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "enabled",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "includeUserCards",
      "value": true
    }
  ],
  "concreteType": "SquareCardOnFileConnection",
  "kind": "LinkedField",
  "name": "squareCards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareCardOnFileEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareCardOnFile",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "enabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cardBrand",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastFour",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "squareCards(enabled:true,includeUserCards:true)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectPaymentModalQuery",
    "selections": [
      {
        "alias": "customer",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ExistingSquareCardsList_customer"
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "type": "Customer",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SelectPaymentModalQuery",
    "selections": [
      {
        "alias": "customer",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "Customer",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3eab6b617e6a4516961a068224665215",
    "id": null,
    "metadata": {},
    "name": "SelectPaymentModalQuery",
    "operationKind": "query",
    "text": "query SelectPaymentModalQuery(\n  $customerId: ID!\n) {\n  customer: node(id: $customerId) {\n    __typename\n    ... on Customer {\n      ...ExistingSquareCardsList_customer\n      id\n      squareCards(includeUserCards: true, enabled: true) {\n        edges {\n          node {\n            id\n            enabled\n            cardBrand\n            expMonth\n            expYear\n            lastFour\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ExistingSquareCardsList_customer on Customer {\n  id\n  squareCards(includeUserCards: true, enabled: true) {\n    edges {\n      node {\n        id\n        enabled\n        cardBrand\n        expMonth\n        expYear\n        lastFour\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cfd1fd2f5f4fdce92ae34c9456c00669";

export default node;
